module.exports = __webpack_public_path__ + "static/media/help.cefe654a.svg";